import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Lead } from '@/types/sales';
import { Building2, Mail, Phone, Calendar, User } from 'lucide-react';

interface LeadCardProps {
  lead: Lead;
  onClick: () => void;
}

const LeadCard: React.FC<LeadCardProps> = ({ lead, onClick }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id: lead.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1
  };

  // Calcular dias na etapa
  const diasNaEtapa = Math.floor(
    (new Date().getTime() - new Date(lead.data_entrada_etapa).getTime()) / (1000 * 60 * 60 * 24)
  );

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <Card
        className="cursor-pointer hover:shadow-md transition-shadow bg-white"
        onClick={onClick}
      >
        <CardContent className="p-4">
          <div className="space-y-3">
            {/* Header */}
            <div>
              <div className="flex items-start justify-between gap-2">
                <h4 className="font-semibold text-sm line-clamp-1">
                  {lead.nome_empresa}
                </h4>
                {diasNaEtapa > 3 && (
                  <Badge variant="outline" className="text-xs border-orange-500 text-orange-700">
                    {diasNaEtapa}d
                  </Badge>
                )}
              </div>
              <p className="text-xs text-muted-foreground mt-1">
                CNPJ: {lead.cnpj}
              </p>
            </div>

            {/* Informações */}
            <div className="space-y-1.5">
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Mail className="h-3 w-3 flex-shrink-0" />
                <span className="truncate">{lead.email}</span>
              </div>
              
              <div className="flex items-center gap-2 text-xs text-muted-foreground">
                <Phone className="h-3 w-3 flex-shrink-0" />
                <span>{lead.telefone}</span>
              </div>

              {lead.vendedor && (
                <div className="flex items-center gap-2 text-xs text-muted-foreground">
                  <User className="h-3 w-3 flex-shrink-0" />
                  <span className="truncate">{lead.vendedor.name}</span>
                </div>
              )}
            </div>

            {/* Footer */}
            <div className="flex items-center justify-between pt-2 border-t">
              {lead.origem && (
                <Badge variant="secondary" className="text-xs">
                  {lead.origem.nome}
                </Badge>
              )}
              
              {lead.is_indicacao && (
                <Badge variant="outline" className="text-xs border-green-500 text-green-700">
                  Indicação
                </Badge>
              )}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default LeadCard;


